import * as React from "react";
import { Children, useEffect, useRef } from "react";
export var Text = function (_a) {
    var children = _a.children, className = _a.className;
    var ref = useRef(null);
    useEffect(function () {
        if (ref.current) {
            var text = Children.toArray(children).join("");
            ref.current.textContent = text;
        }
    }, [children]);
    return React.createElement("div", { ref: ref, className: className });
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Text.tsx
// module id = 170
// module chunks = 1